import React from 'react';
import { Tabs, TabsTrigger } from '@/components/ui/tabs';
import { AnimatedTabsList } from '@/components/ui/animated-tabs-list';
import { Calendar, Grid3x3 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export type CalendarView = 'week' | 'month';

interface CalendarViewToggleProps {
  view: CalendarView;
  onViewChange: (view: CalendarView) => void;
}

export const CalendarViewToggle: React.FC<CalendarViewToggleProps> = ({
  view,
  onViewChange,
}) => {
  const { t } = useTranslation();

  return (
    <Tabs
      value={view}
      onValueChange={value => onViewChange(value as CalendarView)}
      className="w-auto"
    >
      <AnimatedTabsList
        activeValue={view}
        indicatorClassName="bg-brand"
        className="rounded-full border border-border bg-card p-1"
      >
        <TabsTrigger
          value="week"
          className="relative z-10 h-8 gap-2 px-3 text-sm font-medium data-[state=active]:font-medium data-[state=active]:text-brand-foreground"
        >
          <Grid3x3 className="h-4 w-4" />
          <span className="hidden sm:inline">
            {t('agent.calendar.view.week.translation', 'Week')}
          </span>
        </TabsTrigger>
        <TabsTrigger
          value="month"
          className="relative z-10 h-8 gap-2 px-3 text-sm font-medium data-[state=active]:font-medium data-[state=active]:text-brand-foreground"
        >
          <Calendar className="h-4 w-4" />
          <span className="hidden sm:inline">
            {t('agent.calendar.view.month.translation', 'Month')}
          </span>
        </TabsTrigger>
      </AnimatedTabsList>
    </Tabs>
  );
};
